import toast from 'react-hot-toast';
import apiService from '../services/api';
import { downloadCsv } from './analytics';

const shiftDate = (dateStr, days) => {
  const date = new Date(`${dateStr}T00:00:00Z`);
  date.setUTCDate(date.getUTCDate() + days);
  return date.toISOString().slice(0, 10);
};

/**
 * Download the CSV transaction report for the current list filters.
 * Without dates it exports the last 30 days (IST).
 * @param {string} type - payin | payout
 * @param {object} filters - { status, dateFrom, dateTo }
 * @param {string} today - Today's IST date (YYYY-MM-DD)
 */
export const exportTransactionReport = async (type, filters, today) => {
  const toDate = filters.dateTo || (filters.dateFrom && filters.dateFrom > today ? filters.dateFrom : today);
  const fromDate = filters.dateFrom || shiftDate(toDate, -29);

  const response = await apiService.getTransactionReport({
    type,
    format: 'csv',
    status: filters.status || '',
    from_date: fromDate,
    to_date: toDate
  });

  const files = response.success ? response.data?.files || [] : [];
  if (files.length === 0) {
    toast.error(`No ${type === 'payin' ? 'payments' : 'payouts'} found from ${fromDate} to ${toDate}`);
    return;
  }

  files.forEach(file => downloadCsv(file.content, file.filename));
  toast.success(
    filters.dateFrom || filters.dateTo
      ? 'Export completed'
      : `Exported last 30 days (${fromDate} to ${toDate})`
  );
};
